import { faUserDoctor } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography, Button } from '@mui/material';
import './styles.css';
import './sxProps';
import { sxButtonTelessaudeAtendIngressar, sxTypographyTelessaudeSubtitle } from './sxProps';
import HeaderTelessaude from './HeaderTelessaude';
import { StepIngressarAtendProps } from '../../../interfaces/props/SaudeOnline/IngressarNoAtendimento/StepIngressarAtendProps';

const StartIngressarAtend: React.FC<StepIngressarAtendProps> = ({ ...props }) => {

  const { nextStep } = { ...props };

  return (
    <div className='ingressar-atendimento-gap-content'>
      <HeaderTelessaude />
      <Typography sx={sxTypographyTelessaudeSubtitle}>VAMOS COMEÇAR?</Typography>
      <div className='icon-circle-container-102px'>
        <div className='circle-background' />
        <FontAwesomeIcon icon={faUserDoctor} className='fa-doctor-ingressar-atendimento' />
      </div>
      <Button
        type='button'
        variant='contained'
        onClick={nextStep}
        sx={sxButtonTelessaudeAtendIngressar}
      >
        <Typography>INICIAR ATENDIMENTO</Typography>
      </Button>
    </div>
  )

}

export default StartIngressarAtend;